<template>
  <b-container>
    <b-row>
      <b-col>
        <h1>Hilfe</h1>

        <p class="lead">Im Medienarchiv68 finden Sie Artikel aus Medien von Axel Springer vom 1. Dezember 1966 bis 31. Dezember 1968, die sich mit „1968“ und der Studentenbewegung beschäftigen. Zusätzlich stehen ausgewählte Artikel aus Blättern anderer Verlage zur Verfügung.</p>
        <p>Zu jedem Artikel in der Datenbank ist eine pdf-Datei mit einem Scan der jeweiligen Original-Zeitungsseite verfügbar. Zudem enthält die Datenbank neben den Original-Überschriften zusätzlich auch redaktionell bearbeitete Inhaltsangaben zu jedem Artikel, die einer Verbesserung der Suchergebnisse dienen. Eine Volltextsuche ist aufgrund der zu hohen Fehlerrate bei der automatischen Texterkennung der alten Zeitungsseiten leider noch nicht möglich, jedoch für eine nächste Ausbaustufe bereits geplant.</p>
        <h2>Schnellsuche</h2>
        <p>Mit der Schnellsuche können Sie alle Textfelder der Datenbank frei nach Stichworten durchsuchen und sich somit einen ersten Überblick verschaffen. </p>
        <h3>Suchbeispiele:</h3>
        <ul>
          <li>Die Eingabe <em>Kurras Ohnesorg</em> findet beispielsweise sämtliche Artikel, die <strong>beide</strong><strong> Wörter</strong> im Thema, der Überschrift oder den Inhaltsstichworten enthalten. </li>
          <li>Die Eingabe <em>"Kurras und Teufel"</em> (mit Anführungszeichen) findet beispielsweise sämtliche Artikel, die <strong>genau diese Zeichenkette</strong> im Thema, der Überschrift oder den Inhaltsstichworten enthalten.</li>
          <li>Die Suche bevorzugt einzelne Wörter: Eine Suche nach <em>TU</em> gibt beispielsweise zuoberst Artikel mit <em>TU</em> oder <em>TU-Rektor</em> aus, bevor auch Artikel mit dem Wort S<em>tu</em>denten ausgegeben werden.</li>
        </ul>
        <p>Die Ergebnisse können anschließend nach Datum, Medium oder Artikeltitel <strong>sortiert</strong> werden. </p>
        <h3>Erweiterte Suche</h3>
        <p>Diese Suche bietet genaue Abfragemöglichkeiten: Kombinieren Sie sämtliche Felder der Datenbank, um beispielsweise herauszufinden, wie viele Aufmacher sich mit dem Thema <em>Dutschke</em> beschäftigten, oder wie häufig das Wort <em>Demonstration</em> in Überschriften auf der ersten Seite vorkam. </p>
        <h3>Suchhinweise:</h3>
        <ul>
          <li>Je mehr Kriterien Sie auswählen, desto enger fassen Sie das Suchergebnis.</li>
          <li>Im Feld "Titel des Artikels" suchen Sie automatisch im Titel <strong>und</strong> in dessen Über- und Unterzeile, falls vorhanden. </li>
        </ul>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'SearchHelpPage',
    created () {
      store.commit('setBreadcrumb', [{ text: 'Medienarchiv', to: { name: 'archive' } }, 'Hilfe'])
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/SearchHelpPage.vue